<template>
  <div id="app">
    <!--     <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>
  </div>
</template>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;400;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=ZCOOL+QingKe+HuangYou&display=swap');
  /* @import url('https://fonts.googleapis.com/css2?family=Big+Shoulders+Inline+Display:wght@300;400;500&display=swap'); */
  @import url('https://fonts.googleapis.com/css2?family=Big+Shoulders+Text:wght@300;400;500&display=swap');
  @import 'src/assets/styles/mixins.scss';
  ::-webkit-scrollbar {display: none;}
  body {
    /* margin: $body-margin; */
    margin: 0;
    background: #ececec;
    overflow: hidden;
  }

  #app {
    margin: 0;
    padding: 7px;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>

<script>
export default {
  mounted() {
    window.onMessage = {}
  }
}
</script>
